import { AppBar, Box, Dialog, DialogActions, DialogContent, DialogTitle, Toolbar, Divider } from '@vapor/material'

import Page from '../../components/page/page'
import FormLayoutDrawer from './form-layout-drawer'
import { FormLayoutProps } from './form-layout.types'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'

export default function FormLayout(props: FormLayoutProps) {
  const { appearance, title, description, headerReduced, toolbar, children, removePadding } = props
  const { sm } = useBreakpoints()

  switch (appearance.type) {
    case 'DIALOG':
      return (
        <Dialog
          open={appearance.open}
          onClose={appearance.onClose}
          maxWidth={'lg'}
          fullScreen={!sm}
          sx={{
            '& .MuiDialogContent-root': {
              padding: appearance.noContentTopPadding ? '0px' : undefined,
              paddingLeft: appearance.noContentTopPadding ? '24px' : undefined,
              paddingRight: appearance.noContentTopPadding ? '24px' : undefined,
              paddingBottom: appearance.noContentTopPadding ? '24px' : undefined,
            },
            '& .MuiDialog-container': {
              '& .MuiPaper-root': {
                maxWidth: appearance.maxWidth ? (sm ? appearance.maxWidth : '100%') : undefined,
              },
            },
          }}
        >
          <DialogTitle>{title}</DialogTitle>
          <Divider />
          <DialogContent>
            <Box sx={{ mt: 2 }}>{children}</Box>
          </DialogContent>
          <DialogActions>{toolbar}</DialogActions>
        </Dialog>
      )

    case 'DRAWER':
      return (
        <FormLayoutDrawer //
          open={appearance.open}
          onClose={appearance.onClose}
          title={title}
          subtitle={appearance.subtitle}
          toolbar={toolbar}
          width={appearance.width}
          hideTitle={appearance.hideTitle}
          leftNodes={appearance.leftNodes}
          rightNodes={appearance.rightNodes}
          removePadding={appearance.removePadding}
          tight={appearance.tight}
          large={appearance.large}
          titleOnLeft={appearance.titleOnLeft}
          id={appearance?.id}
          superTight={appearance.superTight}
        >
          {children}
        </FormLayoutDrawer>
      )

    case 'RAW':
      return (
        <>
          {children}
          {toolbar}
        </>
      )

    case 'PAGE':
    default:
      return (
        <Page
          title={title}
          description={description}
          headerReduced={headerReduced}
          headerBack={appearance.headerBack}
          fullWidth={appearance.fullWidth}
          hideHeader={appearance.hideHeader}
          leftItems={appearance.leftNodes}
          rightItems={appearance.rightNodes}
          customHeader={appearance.customHeader}
          removeMargin={appearance.removeMargin}
          appBar={
            !appearance.hideToolbar ? (
              <AppBar position="sticky" sx={{ bottom: '0px', width: '100%' }}>
                <Toolbar sx={{ py: 1 }}>{toolbar}</Toolbar>
              </AppBar>
            ) : undefined
          }
          id={appearance.id}
        >
          <Box
            sx={{
              boxSizing: 'border-box',
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <Box sx={{ width: '100%', height: '100%', p: removePadding ? 0 : 1, px: removePadding ? undefined : { lg: 2, xl: 0 }, boxSizing: 'border-box' }}>{children}</Box>
          </Box>
        </Page>
      )
  }
}
